package games.polyclub.website.frontend.store.pages.product

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.a
import games.polyclub.frontend.lib.react.simplified.tags.p
import react.Props
import web.window.WindowTarget

val OriginalMinecraft = SFC<Props> { _ ->
    p {
        +"Em respeito ao "
        a {
            href = "https://www.minecraft.net/pt-br/eula"
            target = WindowTarget._blank
            +"EULA da Mojang "
        }
        +"nós só permitimos acesso ao servidor para jogadores que possuem o jogo original já que o servidor é fechado para quem compra Passe de Acesso. "
        +"Você pode comprar o jogo no "
        a {
            href = "https://www.minecraft.net/pt-br/store/minecraft-java-bedrock-edition-pc"
            target = WindowTarget._blank
            +"site oficial da Mojang clicando aqui."
        }
        +" Ou possuir acesso ao jogo por meios de passes como o "
        a {
            href = "https://www.xbox.com/pt-BR/games/minecraft"
            target = WindowTarget._blank
            +"Game Pass do Xbox (Console ou PC)"
        }
        +"."
    }
}
